import api from "api/axios";

/**
 * ABDM §3.2.7 Find services by bridge id, §3.2.4 Update bridge URL and the
 * §3.2.6 lookup of one Service ID, through drcfo.backend
 * (services/abdmBridge.ts, services/abdmServiceCheck.ts) to abdm.backend, which
 * makes the gateway calls. All answer `{ message, data }`; a failure answers
 * `{ success: false, message }` and is never a 401, so it never signs the
 * admin out.
 */

export async function getAbdmBridge() {
  try {
    return await api.get("/admin/abdm/bridge");
  } catch (err) {
    return err.response;
  }
}

export async function updateAbdmBridgeUrl(url) {
  try {
    return await api.patch("/admin/abdm/bridge/url", { url });
  } catch (err) {
    return err.response;
  }
}

/**
 * Is `serviceId` registered under DRCFO's Bridge ID, judged in `role` ("HIP"
 * or "HIU")? Answers `{ data: { result, holders } }`: the verdict and the
 * doctor profiles whose HIP, HIU or HFR id it is. Nothing is filed on anyone.
 */
export async function lookupAbdmService(serviceId, role = "HIP") {
  try {
    return await api.get("/admin/abdm/service-lookup", { params: { serviceId, role } });
  } catch (err) {
    return err.response;
  }
}

/**
 * Every doctor profile holding a HIP, HIU or HFR ID, for the Bridge page's
 * services table to name who holds each Service ID. Answers
 * `{ data: { doctors } }` (`name, hfrId, hipId, hiuId, status, role.type`).
 */
export async function getAbdmIdHolders() {
  try {
    return await api.get("/admin/abdm/id-holders");
  } catch (err) {
    return err.response;
  }
}
